module.exports = __webpack_public_path__ + "static/sec4-bg-sm-cf800aff2c580846847712ec4a20e7df.jpg";